// extracted by mini-css-extract-plugin
export default {"lang":"lang___c2cd9f84415e577b","lang_hidden":"lang_hidden___ced06cced87c61a1","mobile":"mobile___a64d9c62ce686ea5"};